<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Dashboard</div>
          <div class="card-body">
            <div v-if="user" class="alert alert-success" role="alert">You are logged in!</div>
            <p>{{user}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"

  export default {
    props: ['person'],

    components: {
    },

    data: () => ({
      drawer: false,
      group: null,
    }),

    watch: {
        group () {
          this.drawer = false
        },
      },

      computed: {
        ...mapGetters({
    // map `this.user` to `this.$store.getters.user`
          user: "user"

        })

      },
      methods: {

      }
  };
</script>
